import React, { useContext } from "react";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { Typography } from "@mui/material";
import FormikControlContext from "../../../Contexts/FormikControlContext";
import { ErrorMessage, Field } from "formik";
import TextError from "../TextError";
import useAutoCompleteField from "./useAutoCompleteField";

export default function AutoCompleteField() {
  const field = useContext(FormikControlContext);
  const { label, name, validation, readOnly, hintText } = field;
  const {
    options,
    selectedValue,
    handleOptionSelect,
    handleInputChange,
    loading,
    getOptionLabel,
    renderOption,
  } = useAutoCompleteField();

  return (
    <div>
      {/* <AutoCompleteProvider> */}
      <Typography>
        {label}
        {validation?.required && <span>*</span>}
      </Typography>

      <Field
        id={name}
        name={name}
        component={Autocomplete}
        getOptionLabel={getOptionLabel}
        filterOptions={(x) => x}
        disabled={Boolean(readOnly)}
        options={options}
        autoComplete
        includeInputInList
        filterSelectedOptions
        value={selectedValue}
        onChange={handleOptionSelect}
        loading={loading}
        onInputChange={handleInputChange}
        required={validation?.required ?? false}
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder={hintText || "Search..."}
            fullWidth
            InputProps={{
              ...params.InputProps,
            }}
          />
        )}
        renderOption={renderOption}
      />

      <ErrorMessage name={name} component={TextError} />
      {/* </AutoCompleteProvider> */}
    </div>
  );
}
